export const schoolWishlistVotesKeys = {
    all: ['school-wishlist-votes'] as const,
    voters: (materialId: number) => [...schoolWishlistVotesKeys.all, 'voters', materialId] as const,
    newCount: () => [...schoolWishlistVotesKeys.all, 'new-count'] as const,
} as const;

// Invalidations:
// useMarkSchoolWishlistViewed → schoolWishlistVotesKeys.newCount() (setQueryData(0), no refetch)
// useVoteSchoolWishlist   → schoolWishlistVotesKeys.voters(materialId) + schoolWishlistKeys.all
// useUnvoteSchoolWishlist → schoolWishlistVotesKeys.voters(materialId) + schoolWishlistKeys.all
// useSubscribeSchool      → schoolWishlistVotesKeys.voters(materialId)
// useUnsubscribeSchool    → schoolWishlistVotesKeys.voters(materialId)
//
// Caching: voters(materialId) is cached for VOTERS_STALE_TIME with refetchOnWindowFocus disabled.
// The list is seeded from the base-search payload and kept correct by the invalidations above plus
// the optimistic updates in the vote/unvote mutations, so it never depends on focus/mount refetches.
